module.exports = __webpack_public_path__ + "img/icon-actuator-2.eda64991.svg";